import styles from './Feedback.module.css';

// A small inline spinner for "in flight" states — the second of the three
// feedback layers ("every submit button ... shows a spinner while in
// flight"). Pair it with `disabled={mutation.isPending}` on the button so an
// action can never fire twice from a double click:
//
//   <button disabled={m.isPending}>
//     {m.isPending ? <><Spinner /> {t('...saving')}</> : t('...save')}
//   </button>
//
// CSS-only rotation (Feedback.module.css), respects prefers-reduced-motion.
export function Spinner({ size = 16, className }) {
  return (
    <span
      className={className ? `${styles.spinner} ${className}` : styles.spinner}
      style={{ width: size, height: size }}
      role="status"
      aria-hidden="true"
    />
  );
}

export default Spinner;
